import { WaybillIdView } from '../../../models';
import { ListRange, SearchCriteriaBase } from '../../../../common/models';

export interface ShipmentWaybillMaterialModel {
  referenceType: string;
  referenceNumber: string;
  deliveryNoteNumber: string;
  positionNumber: string;
  material: string;
  enDescription: string;
  quantity: number;
  activitySector: string;
  plant: string;
  mrpController: string;
  gb: string;
  source: string;
}

export class ShipmentWaybillMaterialListSearchCriteria extends SearchCriteriaBase {
  waybillIdView: WaybillIdView;
  constructor(params?: Partial<ShipmentWaybillMaterialListSearchCriteria> | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
